let credentials: { apiKey: string; apiSecret: string } | null = null;

export function setCredentials(apiKey: string, apiSecret: string) {
  credentials = { apiKey, apiSecret };
}

export function getCredentials(): { apiKey: string; apiSecret: string } | null {
  return credentials;
}

export function clearCredentials() {
  credentials = null;
}
